define(["angular", "angular-animate", "angular-bootstrap"], function (angular) {
    "use strict";

    return angular.module("sortingModule", [
        "ngAnimate",
        "ui.bootstrap"
    ]);
});

